import React from 'react';
import { Bug, RotateCw } from 'lucide-react';
import { Button } from '../ui/button';

export const PreviewViewControls: React.FC<{
  showDebugToggle?: boolean;
  debugEnabled?: boolean;
  onDebugChange?: (enabled: boolean) => void;
}> = ({ showDebugToggle = false, debugEnabled = false, onDebugChange }) => (
  <div className="flex shrink-0 items-center justify-center gap-2 border-t border-border px-3 py-2">
    {showDebugToggle ? (
      <Button
        type="button"
        variant={debugEnabled ? 'secondary' : 'outline'}
        size="sm"
        aria-pressed={debugEnabled}
        title={debugEnabled ? 'Hide hardware placement guides' : 'Show hardware placement guides'}
        onClick={() => onDebugChange?.(!debugEnabled)}
      >
        <Bug className="h-4 w-4" />
        Debug
      </Button>
    ) : null}
    <Button
      type="button"
      variant="outline"
      size="sm"
      disabled
      title="3D rotate will be added later"
    >
      <RotateCw className="h-4 w-4" />
      Rotate
    </Button>
  </div>
);
